<template>
  <div>
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">{{ ctitle }}</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="审批状态"
          v-if="$until.checkPrmissions('courseProjectsMangeTeacher', 'addEditDel') && isAdmin == 3">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择">
            <el-option v-for="item in $store.state.reviewStatus" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学年学期">
          <el-select v-model="formInline.term" clearable filterable placeholder="请选择学年学期">
            <el-option v-for="(item, index) in $store.state.termms" :key="index" :label="item.term"
              :value="item.term"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}项目编号`">
          <el-input v-model="formInline.experiment_code" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}项目名称`">
          <el-input v-model="formInline.experiment_name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}类别`">
          <el-select v-model="formInline.experiment_category" clearable filterable placeholder="请选择">
            <el-option v-for="item in $store.state.experimentCategorys" :key="item" :label="item"
              :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}类型`">
          <el-select v-model="formInline.experiment_type" clearable filterable placeholder="请选择">
            <el-option v-for="item in $store.state.experimentTypes" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`课程名称`">
          <el-input v-model="formInline.course_name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item :label="`所属${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_name" clearable filterable
            :placeholder="`请选择所属${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}要求`">
          <el-select v-model="formInline.experiment_requirement" clearable filterable placeholder="请选择">
            <el-option v-for="item in $store.state.experimentRequirements" :key="item" :label="item"
              :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item v-if="$until.checkPrmissions('courseProjectsMangeTeacher', 'addEditDel')">
          <el-button type="primary" v-if="isAdmin == 3" @click="handleAdd()">新增项目申请</el-button>
          <el-button type="primary" v-if="isAdmin == 1" @click="handleAdd()">新增项目</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
            v-if="$until.checkPrmissions('courseProjectsMangeTeacher', 'addEditDel') && isAdmin == 1"
            @click="downloadFile">下载实验实训项目导入模版</el-button>
        </el-form-item>
        <el-form-item v-if="$until.checkPrmissions('courseProjectsMangeTeacher', 'addEditDel') && isAdmin == 1">
          <Importt :uploadSectionFile="uploadSectionFile" @refresh="handleQuery" :action="action" :params="params"
            :btnTitle="btnTitle"></Importt>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="experiment_name" fixed :label="`${$store.state.themeTitle}项目名称`" width="160px">
        </custom-table-column>
        <custom-table-column prop="experiment_code"  :label="`${$store.state.themeTitle}项目编号`" width="160px">
        </custom-table-column>
        <custom-table-column prop="course_project_code" :label="`${$store.state.themeTitle}项目代码`" width="160px">
        </custom-table-column>
        <custom-table-column prop="status_text"
          v-if="$until.checkPrmissions('courseProjectsMangeTeacher', 'addEditDel') && isAdmin == 3" label="审批状态"
          width="100">
        </custom-table-column>
        <custom-table-column prop="status_remark"
          v-if="$until.checkPrmissions('courseProjectsMangeTeacher', 'addEditDel') && isAdmin == 3" label="审批原因"
          width="160">
        </custom-table-column>
        <custom-table-column prop="instructor_name" label="指导老师" width="120">
        </custom-table-column>
        <custom-table-column prop="training_room_name" :label="`所属${$store.state.themeTitle}室`" width="160">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属院系" width="180">
        </custom-table-column>
        <custom-table-column prop="structure_2" label="专业" width="180">
        </custom-table-column>
        <custom-table-column prop="class_name" label="班级" width="180">
        </custom-table-column>
        <custom-table-column prop="task_name" label="典型任务名称" width="160">
        </custom-table-column>
        <custom-table-column prop="course_name" label="所属课程名称" width="160">
        </custom-table-column>
        <custom-table-column prop="term" label="学年学期" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.xn }} {{ scope.row.term }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="cycle_type" label="周期" width="100">
        </custom-table-column>
        <custom-table-column prop="custom_weeks" label="自定义周次" width="100">
        </custom-table-column>
        <custom-table-column prop="week_start" label="开始周次" width="100">
        </custom-table-column>
        <custom-table-column prop="week_end" label="结束周次" width="100">
        </custom-table-column>
        <custom-table-column prop="sector_start" label="开始节次" width="100">
        </custom-table-column>
        <custom-table-column prop="sector_end" label="结束节次" width="100">
        </custom-table-column>
        <custom-table-column prop="xq" label="星期" width="100">
        </custom-table-column>
        <custom-table-column prop="is_virtual" label="是否仿真虚拟项目" :formatter="format_status_iss" width="160">
        </custom-table-column>
        <custom-table-column prop="resource_names" label="配套资源名称" width="160">
        </custom-table-column>
        <custom-table-column prop="experiment_category" :label="`${$store.state.themeTitle}类别`" width="160">
        </custom-table-column>
        <custom-table-column prop="experiment_type" :label="`${$store.state.themeTitle}类型`" width="160">
        </custom-table-column>
        <custom-table-column prop="experiment_requirement" :label="`${$store.state.themeTitle}要求`" width="160">
        </custom-table-column>
        <custom-table-column prop="skill_requirement" label="技能要求" width="160">
        </custom-table-column>
        <custom-table-column prop="assessment_method" label="考核方式" width="160">
        </custom-table-column>
        <custom-table-column prop="module_count" label="模块数量" width="160">
        </custom-table-column>
        <custom-table-column prop="is_external_service" label="是否对外服务" :formatter="format_status_iss" width="160">
        </custom-table-column>
        <custom-table-column prop="participant_types" :label="`${$store.state.themeTitle}者类别`" width="160">
        </custom-table-column>
        <custom-table-column prop="participant_count" :label="`${$store.state.themeTitle}人数`" width="160">
        </custom-table-column>
        <custom-table-column prop="group_size" label="每组人数" width="160">
        </custom-table-column>
        <custom-table-column prop="experiment_hours" :label="`${$store.state.themeTitle}学时数`" width="160">
        </custom-table-column>
        <custom-table-column prop="other_location" label="其他实训地点" width="160">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope" v-if="$until.checkPrmissions('courseProjectsMangeTeacher', 'addEditDel')">
            <template v-if="isAdmin != 2">
              <el-button v-if="!(isAdmin == 3 && scope.row.status == 2)"
                @click="handleEditNew(scope.row, ['id'], () => handleEditInit(scope.row))" type="text"
                size="small">编辑</el-button>
              <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
            <template v-if="isAdmin == 2">
              <el-button @click="handleEditNew(scope.row, ['id'], () => handleEditInit(scope.row))" type="text"
                size="small">变更项目</el-button>
            </template>
          </template>
          <template slot-scope="scope" v-if="$store.state.userInfo && $store.state.userInfo.usertype == 4">
            <el-button @click="handleSign(scope.row)" type="text" size="small">签到</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="786px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
        <el-form-item :label="`${$store.state.themeTitle}项目名称`" prop="experiment_name">
          <el-input v-model="ruleForm.experiment_name" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}项目编号`" prop="experiment_code">
          <el-input v-model="ruleForm.experiment_code" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}项目代码`" prop="course_project_code">
          <el-input v-model="ruleForm.course_project_code" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <!-- <el-form-item label="所属组织结构" prop="structure_1">
          <el-input v-model="selectName" placeholder="请选择" style="width:572px;" @focus="dialogOpen"
            @clear="handeleClear" clearable></el-input>
          <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell"
            @handleOrganQuery="handleOrganQueryNew({ limit: false, major: 'structure_2' })">
          </OrganDialog>
        </el-form-item> -->
        <el-form-item :label="`${$store.state.themeTitle}类别`" prop="experiment_category">
          <el-select v-model="ruleForm.experiment_category" clearable :placeholder="`请选择`" style="width: 216px;">
            <el-option v-for="item in $store.state.experiments" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}类型`" prop="experiment_type">
          <el-select v-model="ruleForm.experiment_type" clearable :placeholder="`请选择`" style="width: 216px;">
            <el-option v-for="item in $store.state.projects" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="指导老师" prop="instructor_id">
          <el-select v-model="ruleForm.instructor_id" style="width:216px;"
            @change="handleTeacherChange($event, 'instructor_number', 'instructor_name')" filterable :loading="loading"
            remote :remote-method="remoteMethod" placeholder="请选择">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
              <p>{{ item.name }}</p>
              <p v-if="item.number" class="el-option-tips">工号：{{ item.number }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="典型任务名称" prop="task_name">
          <el-input v-model="ruleForm.task_name" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}课程`" prop="course_id">
          <el-select v-model="ruleForm.course_id" clearable filterable remote :remote-method="getCourseList"
            :loading="loading1" :placeholder="`请选择`" @change="handleCourseChange" style="width: 216px;">
            <el-option v-for="item in courseList" :key="item.id" :label="item.course_name" :value="item.id">
              <p>{{ item.course_name }}（{{ item.course_no }}）</p>
              <p v-if="item.training_name" class="el-option-tips">所属实训室：{{ item.training_name }}</p>
              <p v-if="item.class_teacher" class="el-option-tips">任课老师：{{ item.class_teacher }}</p>
              <p v-if="item.term" class="el-option-tips">学年学期：{{ item.xn }} {{ item.term }}</p>
              <p v-if="item.structure_1" class="el-option-tips">组织结构：{{ item.structure_1 }}-{{ item.structure_2 }}-{{
                item.class_name }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="周期" prop="cycle_type">
          <el-radio-group v-model="ruleForm.cycle_type" style="width:532px;">
            <el-radio v-for="item in $store.state.cycles" :key="item" :label="item">{{ item
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="自定义周次" v-if="ruleForm.cycle_type == '自定义'" prop="custom_weeks"
          :rules="[{ required: true, message: '请输入', trigger: 'blur' }]">
          <el-input v-model="ruleForm.custom_weeks"
            @input="ruleForm.custom_weeks = $event.replace(/，/g, ',').replace(/[^0-9,]/g, '')"
            placeholder="具体周次，逗号分隔，例1,3" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="开始周次" prop="week_start">
          <el-input v-model="ruleForm.week_start" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="结束周次" prop="week_end">
          <el-input v-model="ruleForm.week_end" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="开始节次" prop="sector_start">
          <el-input v-model="ruleForm.sector_start" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="结束节次" prop="sector_end">
          <el-input v-model="ruleForm.sector_end" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="星  期" prop="xq">
          <el-select v-model="ruleForm.xq" clearable placeholder="请选择" style="width:216px;">
            <el-option v-for="item in $store.state.weeks" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学年学期" prop="term">
          <el-select v-model="xnTerm" clearable filterable placeholder="请选择">
            <el-option v-for="(item, index) in $store.state.termms" :key="index" :label="item.term"
              :value="item.term"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="学年学期" prop="term">
          <el-select v-model="ruleForm.term" clearable filterable placeholder="请选择">
            <el-option v-for="(item, index) in $store.state.termms" :key="index" :label="item.term"
              :value="item.term"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="是否仿真虚拟项目" prop="is_virtual">
          <el-select v-model="ruleForm.is_virtual" clearable style="width:216px;" placeholder="请选择">
            <el-option v-for="item in $store.state.iss" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="配套资源名称" prop="resource_names">
          <el-input v-model="ruleForm.resource_names" placeholder="请输入,多个用逗号隔开" style="width:572px;"></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}要求`" prop="experiment_requirement">
          <el-select v-model="ruleForm.experiment_requirement" clearable :placeholder="`请选择`" style="width: 216px;">
            <el-option v-for="item in $store.state.requires" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="技能要求" prop="skill_requirement">
          <el-input v-model="ruleForm.skill_requirement" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="考核方式" prop="assessment_method">
          <el-input v-model="ruleForm.assessment_method" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="模块数量" prop="module_count">
          <el-input v-model="ruleForm.module_count" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="是否对外服务" prop="is_external_service">
          <el-select v-model="ruleForm.is_external_service" clearable style="width:216px;" placeholder="请选择">
            <el-option v-for="item in $store.state.iss" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}者类别`" prop="participant_types">
          <el-select v-model="ruleForm.participant_types" clearable multiple :placeholder="`请选择`" style="width: 216px;">
            <el-option v-for="item in $store.state.participantTypes" :key="item" :label="item"
              :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}人数`" prop="participant_count">
          <el-input v-model="ruleForm.participant_count" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="每组人数" prop="group_size">
          <el-input v-model="ruleForm.group_size" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}学时数`" prop="experiment_hours">
          <el-input v-model="ruleForm.experiment_hours" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室`" prop="training_room_id">
          <el-select v-model="ruleForm.training_room_id" filterable style="width:216px;"
            :placeholder="`请选择${$store.state.themeTitle}室`" @change="handleClassChange">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`其他${$store.state.themeTitle}`" prop="other_location">
          <el-input v-model="ruleForm.other_location" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 签到弹窗 -->
    <el-dialog :close-on-click-modal="false" title="签到" :visible.sync="signDialogVisible" width="480px">
      <el-form :model="signForm" ref="signForm" label-width="100px">
        <el-form-item label="课程名称">
          <el-input v-model="signForm.course_title" disabled style="width:302px;"></el-input>
        </el-form-item>
        <el-form-item label="周次" prop="week_count" :rules="[{ required: true, message: '请选择周次', trigger: 'change' }]">
          <el-select v-model="signForm.week_count" clearable placeholder="请选择周次" style="width:302px;">
            <el-option v-for="w in 16" :key="w" :label="`第${w}周`" :value="w"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="节次" prop="node_count" :rules="[{ required: true, message: '请选择节次', trigger: 'change' }]">
          <el-select v-model="signForm.node_count" clearable placeholder="请选择节次" style="width:302px;">
            <el-option v-for="p in 10" :key="p" :label="`第${p}节`" :value="p"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="当前时间">
          <el-input v-model="signForm.sign_time" disabled style="width:302px;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="signDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSignSubmit">签到</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinFormatter } from '@/assets/js/mixin/formatter';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';

export default {
  props: {
    isAdmin: {
      type: Number,
      default: 1,
    },
    ctitle: {
      type: String,
      default: '',
    },
  },
  name: 'equipmentInto',
  mixins: [mixinList, mixinValidate, mixinFormatter, mixinOrgan, mixinImport],
  data() {
    return {
      activeName: '1',
      formInline: {
        experiment_code: '',
        experiment_name: '',
        experiment_category: '',
        experiment_type: '',
        structure_1: '',
        structure_2: '',
        course_name: '',
        training_room_id: '',
        experiment_requirement: '',
        term: ''
      },
      ruleForm: {
        experiment_code: '',
        experiment_name: '',
        course_project_code: '',
        instructor_id: '',
        instructor_name: '',
        instructor_number: '',
        task_name: '',
        course_id: '',
        course_name: '',
        term: '',
        is_virtual: '',
        resource_names: '',
        experiment_category: '',
        experiment_type: '',
        structure_1: '',
        structure_2: '',
        experiment_requirement: '',
        skill_requirement: '',
        assessment_method: '',
        module_count: '',
        is_external_service: '',
        participant_types: '',
        participant_count: '',
        group_size: '',
        experiment_hours: '',
        training_room_id: '',
        training_room_no: '',
        training_room_name: '',
        other_location: '',
        cycle_type: '',
        custom_weeks: '',
        large_schedule_id: '',
        xq: '',
        week_start: '',
        week_end: '',
        sector_start: '',
        sector_end: '',
        xn: '',
      },
      xnTerm: '',
      rules: {
        experiment_code: [{ required: true, message: '请输入', trigger: 'blur' }],
        course_project_code: [{ required: true, message: '请输入', trigger: 'blur' }],
        experiment_name: [{ required: true, message: '请输入', trigger: 'blur' }],
        teacher_name: [{ required: true, message: '请选择', trigger: 'change' }],
        instructor_id: [{ required: true, message: '请选择', trigger: 'change' }],
        task_name: [{ required: true, message: '请输入', trigger: 'blur' }],
        course_id: [{ required: true, message: '请选择', trigger: 'change' }],
        // term: [{ required: true, message: '请选择', trigger: 'change' }],
        is_virtual: [{ required: true, message: '请选择', trigger: 'change' }],
        experiment_category: [{ required: true, message: '请选择', trigger: 'change' }],
        experiment_type: [{ required: true, message: '请选择', trigger: 'change' }],
        // structure_1: [{ required: true, message: '请选择', trigger: 'change' }],
        experiment_requirement: [{ required: true, message: '请选择', trigger: 'change' }],
        skill_requirement: [{ required: true, message: '请输入', trigger: 'blur' }],
        assessment_method: [{ required: true, message: '请输入', trigger: 'blur' }],
        module_count: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkInt, trigger: 'blur' }],
        is_external_service: [{ required: true, message: '请选择', trigger: 'change' }],
        participant_types: [{ required: true, message: '请选择', trigger: 'change' }],
        participant_count: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkInt, trigger: 'blur' }],
        group_size: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkInt, trigger: 'blur' }],
        experiment_hours: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkfloat, trigger: 'blur' }],
        training_room_id: [{ required: true, message: '请选择', trigger: 'change' }],
        cycle_type: [{ required: true, message: '请选择', trigger: 'change' }],
        week_start: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkInt, trigger: 'blur' }],
        week_end: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkInt, trigger: 'blur' }],
        sector_end: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkInt, trigger: 'blur' }],
        sector_start: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkInt, trigger: 'blur' }],
        xq: [{ required: true, message: '请选择', trigger: 'change' }],
        term: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      courseList: [],
      users: [],
      action: '',
      downloadUrl: 'template/实验实训项目导入模版.xlsx',
      downloadName: '实验实训项目导入模版.xlsx',
      btnTitle: '导入实验实训项目',
      loading: false,
      loading1: false,
      signDialogVisible: false,
      signForm: {
        course_id: '',
        course_projects_id: '',
        course_title: '',
        week_count: '',
        node_count: '',
        sign_time: '',
        structure_1: '',
        training_room_no: '',
      },
      signCurrentRow: null,
    };
  },
  created() {
    this.action = `${this.baseUrlt}api/course-projects/import`;
    this.$store.dispatch('getTarinMent');
    this.$store.dispatch('getTermms');

    // 
  },
  watch: {
    'xnTerm': {
      handler: function (val) {
        if (val) {
          // console.log(val.split('|'))
          this.ruleForm.term = val.split(' ')[1] ? val.split(' ')[1] : ''
          this.ruleForm.xn = val.split(' ')[0]
          // this.ruleForm = val.split(' ')
        } else {
          this.ruleForm.term = ''
          this.ruleForm.xn = ''
        }
      },
      deep: false,
    },
  },
  mounted() {
  },
  methods: {
    handleTabClick(val) {
    },
    async deleteMethod() {
      let path = `api/course-projects/delete/${this.delid}`
      if (this.isAdmin == 3) {
        path = `api/course-project-applications/delete/${this.delid}`
      }
      let res = await this.$api.instance.interfaceServer(path, 'delete');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    handleEditInit(row) {
      if (row.instructor_id && JSON.stringify(this.users).indexOf(row.instructor_id) == -1) {
        this.users.push({ id: row.instructor_id, name: row.instructor_name, number: row.instructor_number })
      }
      this.handleEditCallBackSetStruc({ major: 'structure_2', row })
      this.ruleForm.participant_types = (row.participant_types ? row.participant_types.split(',') : []);
      this.xnTerm = (this.ruleForm.xn ? (this.ruleForm.xn + ' ') : '') + this.ruleForm.term
      if (row.course_id && JSON.stringify(this.courseList).indexOf(row.course_id) == -1) {
        this.courseList.push({ id: row.course_id, course_name: row.course_name, course_no: row.course_no })
      }
      // this.getCourseList()
    },
    async remoteMethod(query) {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
        type: "1,3,7"
      };
      let res = await this.$api.query.getUsersUnLoad(params);
      if (res.code == 0 && res.data) {
        this.users = res.data.data;
      }
      this.loading = false;

      // this.users = res.data.data;
    },
    handleClassChange(e) {
      this.ruleForm.training_room_name = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
      this.ruleForm.training_room_no = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_no', e);
    },
    handleCourseChange(e) {
      // this.ruleForm.course_name = this.$until.getLabelName(this.courseList, 'id', 'course_name', e);
      // this.ruleForm.term = this.$until.getLabelName(this.courseList, 'id', 'xn', e) + ' ' + this.$until.getLabelName(this.courseList, 'id', 'term', e);
      const item = this.$until.getLabelNameNew({ arr: this.courseList, id: e })
      this.ruleForm.course_name = item.course_name
      this.ruleForm.term = item.term
      this.ruleForm.structure_1 = item.structure_1
      this.ruleForm.structure_2 = item.structure_2
      this.ruleForm.class_name = item.class_name
      this.ruleForm.cycle_type = item.cycle_type
      this.ruleForm.custom_weeks = item.custom_weeks
      // this.ruleForm.large_schedule_id = item.large_schedule_id
      this.ruleForm.xq = item.xq
      this.ruleForm.week_start = item.week_start
      this.ruleForm.week_end = item.week_end
      this.ruleForm.sector_start = item.sector_start
      this.ruleForm.sector_end = item.sector_end
      this.ruleForm.xn = item.xn
      this.xnTerm = item.xn + ' ' + item.term

    },
    handleTeacherChange(val, name, number) {
      this.ruleForm[name] = this.$until.getLabelName(this.users, 'id', 'name', val);
      this.ruleForm[number] = this.$until.getLabelName(this.users, 'id', 'number', val);
    },
    async getCourseList(query) {
      // if (this.courseList && this.courseList.length) {
      //   return
      // }
      this.loading1 = true
      let res = await this.$api.query.getClassPlanList({ page: 1, size: 9999, apply_status: 'pass', course_name: query });
      this.loading1 = false
      if (res.code == 0 && res.data) {
        this.courseList = res.data.data;
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let path = 'api/course-projects/list'
      if (this.isAdmin == 3) {
        path = "api/course-project-applications/list"
      }
      let res = await this.$api.instance.interfaceServer(path, 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      params.participant_types = params.participant_types.join(',');
      let path = 'api/course-project-applications/store'
      if (this.isAdmin == 1) {
        path = "api/course-projects/store"
      }
      let res = await this.$api.instance.interfaceServer(path, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      params.participant_types = params.participant_types.join(',');
      let path = `api/course-projects/update/${params.id}`
      if (this.isAdmin == 1) {
        path = `api/course-projects/admin-update/${params.id}`
      } else if (this.isAdmin == 3) {
        path = `api/course-project-applications/update/${params.id}`
      }
      let res = await this.$api.instance.interfaceServer(path, 'put', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    // 打开签到弹窗
    handleSign(row) {
      this.signCurrentRow = row;
      this.signForm.course_id = row.course_id || '';
      this.signForm.course_projects_id = row.id || '';
      this.signForm.course_title = row.course_name || '';
      this.signForm.structure_1 = row.structure_1 || '';
      this.signForm.training_room_no = row.training_room_no || '';
      this.signForm.week_count = '';
      this.signForm.node_count = '';
      // 默认当前时间，精确到时分秒
      const now = new Date();
      const h = String(now.getHours()).padStart(2, '0');
      const m = String(now.getMinutes()).padStart(2, '0');
      const s = String(now.getSeconds()).padStart(2, '0');
      this.signForm.sign_time = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${h}:${m}:${s}`;
      this.signDialogVisible = true;
    },
    // 提交签到
    async handleSignSubmit() {
      const valid = await this.$refs.signForm.validate().catch(() => false);
      if (!valid) return;
      const params = {
        course_id: String(this.signForm.course_id),
        course_projects_id: String(this.signForm.course_projects_id),
        course_title: this.signForm.course_title,
        week_count: String(this.signForm.week_count),
        node_count: String(this.signForm.node_count),
        sign_time: this.signForm.sign_time,
        structure_1: this.signForm.structure_1,
        training_room_no: this.signForm.training_room_no,
      };
      const res = await this.$api.instance.interfaceServer('api/sign-in/create', 'post', params);
      if (res.code === 0) {
        this.$message({ type: 'success', center: true, message: '签到成功！' });
        this.signDialogVisible = false;
        this.handleQuery();
      }
    },
    handleQuery() {
      this.beforeQueryByKeyNew({ major: 'structure_2' })
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
@media screen and (max-width: 1000px) {
  .pageHeader {
    border-bottom: 0;
  }

  /deep/.header-info-icon {
    bottom: 18px;
  }
}

@media screen and (min-width: 1000px) {
  .pageHeader {
    display: none;
  }
}
</style>
